odoo.define('@climb_website_optional_cookie_embed_fix/js/optional_cookie_embed_early_fixup', [], function (require) {
'use strict';
let __exports = {};
/**
 * Odoo blocks third-party embeds server-side with data-need-cookies-approval when
 * optional cookies are not accepted. generate_video_iframe.js (assets_frontend_minimal)
 * blanks iframe src on DOMContentLoaded based on that attribute only - it does not
 * read website_cookies_bar. Cached HTML (e.g. Cloudflare) can still carry the attribute
 * after the user has accepted cookies, so embeds stay blocked until reload logic runs.
 *
 * This script runs after generate_video_iframe's DOMContentLoaded handler and restores
 * embeds when consent is already stored in the browser.
 */
(function () {
    "use strict";

    const COOKIE_REGEX = /(^|(; ))website_cookies_bar=(?<value>[^;]+)/;

    function isOptionalCookiesAccepted() {
        const raw = document.cookie.match(COOKIE_REGEX)?.groups.value;
        if (!raw) {
            return false;
        }
        try {
            const consents = JSON.parse(raw);
            return typeof consents === "object" && consents.optional === true;
        } catch {
            return false;
        }
    }

    function restoreBlockedEmbed(iframeEl) {
        const src = iframeEl.dataset.nocookieSrc;
        if (!src) {
            return;
        }
        iframeEl.src = src;
        delete iframeEl.dataset.nocookieSrc;
        delete iframeEl.dataset.needCookiesApproval;
    }

    function restoreBlockedEmbeds() {
        if (!isOptionalCookiesAccepted()) {
            return;
        }
        for (const container of document.querySelectorAll("[data-need-cookies-approval]")) {
            delete container.dataset.needCookiesApproval;
            for (const iframeEl of container.querySelectorAll("iframe")) {
                restoreBlockedEmbed(iframeEl);
            }
        }
        document.dispatchEvent(new Event("optionalCookiesAccepted"));
    }

    document.addEventListener("DOMContentLoaded", restoreBlockedEmbeds);
})();

return __exports;
});
